import PropTypes from "prop-types";
import styles from "./MultipleChoiceVotesList.module.css";

/**
 * View component. Displays a list of multiple-choice options with the number of votes to the right of the option
 */
export function MultipleChoiceVotesList({ results = [] }) {
  return (
    <>
      {results.sort((a,b) => b.votes - a.votes).map((result) => {
        return (
          <div className={styles.resultRow}>
            <div className={styles.optionName}>{result.optionName}</div>
            <div className={styles.votes}>{result.votes}</div>
          </div>
        );
      })}
    </>
  );
}

MultipleChoiceVotesList.propTypes = {
  results: PropTypes.arrayOf({
    optionName: PropTypes.string,
    votes: PropTypes.number,
  }),
};
